import { useEffect, useState } from "react";
import { GET_COUNTIES } from "../api/constants";

const useCounties = () => {
  const [counties, setCounties] = useState([]);
  const [counties_list, setList] = useState([]);
  

  useEffect(() => {
    const fetchCounties = async () => {
      try {
        const response = await fetch(GET_COUNTIES);
        const data = await response.json();

        // ✅ tolerate different API shapes
        if (Array.isArray(data?.data.counties)) {
          setCounties(data.data.counties);
          setList(data.data.countyList)
        } else if (Array.isArray(data)) {
          setCounties(data);
        } else {
          setCounties([]);
        }
      } catch (err) {
        console.error("Error fetching counties:");
      } 
    };

    fetchCounties();
  }, []);

  return { counties, counties_list };
};


export default useCounties;
